import type { CustomerRevenueReportItem } from '@vy/types';
import { useMemo } from 'react';
import {
  buildChartData,
  type ChartPeriodMode,
  type CustomerRevenueChartDataPoint,
} from './customer-revenue-chart-aggregation';

export type { ChartPeriodMode, CustomerRevenueChartDataPoint };

type UseCustomerRevenueReportChartDataParams = {
  reportItems: CustomerRevenueReportItem[];
  fromDate?: Date | null;
  toDate?: Date | null;
  periodMode: ChartPeriodMode;
};

export function useCustomerRevenueReportChartData({
  reportItems,
  fromDate,
  toDate,
  periodMode,
}: UseCustomerRevenueReportChartDataParams): CustomerRevenueChartDataPoint[] {
  return useMemo(
    () => buildChartData(reportItems, fromDate ?? null, toDate ?? null, periodMode),
    [reportItems, fromDate, toDate, periodMode],
  );
}
